import script from "./aiChat.vue?vue&type=script&setup=true&lang=ts"
export * from "./aiChat.vue?vue&type=script&setup=true&lang=ts"

import "./aiChat.vue?vue&type=style&index=0&id=2220b5a4&scoped=true&lang=css"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2220b5a4"]])

export default __exports__